import { render, staticRenderFns } from "./_symbol.vue?vue&type=template&id=af9cdb9c&"
import script from "./_symbol.vue?vue&type=script&lang=js&"
export * from "./_symbol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DetailNav: require('/src/components/detail/detail_nav.vue').default})
